import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import actions from "@redux/esign/actions";
import { palette, size } from "styled-theme";
import { stickyStyled, withMobileSticky } from "../sticky";
import { themes } from "@theme/config/theme.config";
import { APP_STATE } from "../../constants/commonConstants";
import { YesLoansLogo } from "./YesLoansLogo";
import { FairGoLogo } from "./FairGoLogo";
import { RentBondLogo } from "./RentBondLogo";
import { ClearScoreLogo } from "./ClearScoreLogo";
import { OverflowLogo } from "./OverflowLogo";
import { MessagingBanner } from "../messagingBanner/messagingBanner";
import contentDeliveryActions from "@redux/contentDelivery/actions";
import PropTypes from "prop-types";
import { LoanOptionsLogo } from "./LoanOptionsLogo";
import { NimbleLogo } from "./NimbleLogo";
import { withFilteredProps } from '@components/withFilteredProps/withFilteredProps';
import environmentSettings from "@src/constants/environmentSettings";
import VwoScript from "../vwoScript";
import Favicon from "../favicon";

export const _TopHeaderWrapper = styled.div`
  height: 60px;
  color: ${palette("header", 2)};
  background-color: ${palette("color", 16)};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  @media only screen and (max-width: ${size("S")}) {
    margin-bottom: 70px;
  }
`;

export const LogoGroupWrapper = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 1em;
`;

export const PartnerLogoGroupWrapper = styled.div`
  padding-left: 2em;
  color: ${palette("color", 15)};
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 14px;

  p {
    opacity: 0.8;
  }
`;

export const TopHeaderWrapper = withFilteredProps(_TopHeaderWrapper);

export const _StickyTopFloating = withMobileSticky(stickyStyled("nav")``);

export const StickyTopFloating  = withFilteredProps(_StickyTopFloating);

export const PartnerLogo = () => {
  const themeName = useSelector((state) => state.StartUp.theme.themeName);
  let PartnerLogoComponent;
  if (themeName === themes.fgfParent.rent.themeName) {
    PartnerLogoComponent = <RentBondLogo/>;
  }
  if (themeName === themes.fgfParent.clearScore.themeName) {
    PartnerLogoComponent = <ClearScoreLogo/>;
  }
  if (themeName === themes.fgfParent.overflow.themeName) {
    PartnerLogoComponent = <OverflowLogo/>;
  }
  if (themeName === themes.fgfParent.yesLoans.themeName) {
    PartnerLogoComponent = <YesLoansLogo/>;
  }
  if (themeName === themes.fgfParent.loanOptions.themeName) {
    PartnerLogoComponent = <LoanOptionsLogo/>;
  }
  if (themeName === themes.nimbleParent.default.themeName) {
    PartnerLogoComponent = <NimbleLogo/>;
  }
  
  return PartnerLogoComponent;
};

export const Logo = ({ onClick }) => {
  const themeName = useSelector((state) => state.StartUp.theme.themeName);
  const [themeIsFgf, setThemeIsFgf] = useState(true);

  useEffect(() => {
    if (themeName) {
      setThemeIsFgf(themeName === themes.fgfParent.default.themeName || themeName === themes.defaultFallback.themeName);
    }
  }, [themeName]);

  return (
    <LogoGroupWrapper>
      <FairGoLogo onClick={onClick} />
      {!themeIsFgf && (
        <PartnerLogoGroupWrapper>
          <p>Welcome from:</p>
          <PartnerLogo />
        </PartnerLogoGroupWrapper>
      )}
    </LogoGroupWrapper>
  );
};

export const TopHeader = ({ renderHeaderBottom = () => {}, children }) => {
  const { currentEsignPageIndex } = useSelector((state) => state.esign);
  const { bannerData, bannerDataState } =
    useSelector((state) => state.ContentDelivery) || {};
  
  const { cdsApp } = environmentSettings;

  const [filteredMessaging, setFilteredMessaging] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (bannerData && bannerData.length > 0) {
      return;
    } else {
      if (bannerDataState === "") {
        dispatch(contentDeliveryActions.getBannerContentData());
      } else {
        return;
      }
    }
  }, [dispatch, bannerData, bannerDataState]);

  useEffect(() => {
    if (bannerData && bannerData.length > 0) {
      setFilteredMessaging(
        bannerData.filter((data) =>
          data.attributes.web_applications.data
            .map((values) => values.attributes.appName)
            .includes(cdsApp)
        )
      );
    }
  }, [bannerData]);

  const resetEsignFlow = () => {
    if ([1, 2, 3].includes(currentEsignPageIndex)) {
      dispatch(actions.currentEsignPageIndex(0));
    } else {
      return;
    }
  };

  const themeName = useSelector((state) => state.StartUp.theme);
  const isNimbleSite = (window.location.href).includes('nimble');

  return (
    <StickyTopFloating>
      <Favicon isNimbleSite={isNimbleSite} />
      {!isNimbleSite && <VwoScript />}
      {bannerDataState === APP_STATE.READY && (
        <>
          {filteredMessaging.map((data) => {
            return (
              <MessagingBanner
                key={data.attributes.messageName}
                bannerMessagingData={data.attributes}
              />
            );
          })}
        </>
      )}
      <TopHeaderWrapper themeName={themeName}>
        <Logo onClick={resetEsignFlow} />
        {renderHeaderBottom()}
      </TopHeaderWrapper>
      {children}
    </StickyTopFloating>
  );
};

Logo.propTypes = {
  onClick: PropTypes.any,
};

TopHeader.propTypes = {
  mobileHeader: PropTypes.string,
  children: PropTypes.object,
};
